import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  LayoutDashboard,
  History,
  UserPen,
  LogOut,
  UserCircle,
} from "lucide-react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { clearCart } from "../../redux/slices/cart";
import { logout } from "../../redux/slices/auth";
import { fetchStripeAccountUrl } from "../../hooks/api/stripe";
import OrderHistory from "../OrderHistory/OrderHistory";
import AccountSettings from "../AccountSettings/AccountSettings";
import "./UserProfile.css";
import { toast } from "react-toastify";

function UserProfile() {
  const { user } = useSelector((state) => state.auth);
  const token = useSelector((state) => state.auth.token);
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab") || "order-history";
  const [select, setSelect] = useState(tabFromUrl);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  console.log(user);

  useEffect(() => {
    const currentTab = searchParams.get("tab");
    if (currentTab !== select) {
      setSearchParams({ tab: select }, { replace: true });
    }
  }, [select, searchParams, setSearchParams]);

  const handleStripeLogin = async () => {
    try {
      const response = await fetchStripeAccountUrl(token);

      if (response.onboarding_completed) {
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }

      window.location.href = response.url;
    } catch (err) {
      console.error("Failed to get Stripe login link:", err);
    }
  };

  const handleLogout = () => {
    dispatch(clearCart());
    dispatch(logout());
    navigate("/");
  };

  return (
    <section className="UserProfile">
      <ul>
        <li>
          <UserCircle strokeWidth={1.5} size={60} color="white" />
          <p>{user && user.display_name}</p>
        </li>

        {(user.role === "author" || user.is_admin) && (
          <li>
            <Link to="https://shop.leftkoast.com/wp-admin">
              <LayoutDashboard color="white" size={18} />
              Dashboard
            </Link>
          </li>
        )}
        <li
          className={select === "order-history" ? "active" : ""}
          onClick={() => setSelect("order-history")}
        >
          <p>
            <History color="white" size={18} /> Order History
          </p>
        </li>
        <li
          className={select === "account-settings" ? "active" : ""}
          onClick={() => setSelect("account-settings")}
        >
          <p>
            <UserPen color="white" size={18} /> Account Settings
          </p>
        </li>
        {user.role === "author" && user.stripe_account_id && (
          <li>
            <button
              className="stripe-connect"
              onClick={() => {
                handleStripeLogin();
              }}
            >
              <LayoutDashboard color="white" size={18} />
              Stripe Connect
            </button>
          </li>
        )}
        <li>
          <button onClick={handleLogout}>
            <LogOut size={18} />
            Logout
          </button>
        </li>
      </ul>
      {select === "order-history" ? <OrderHistory /> : <AccountSettings />}
    </section>
  );
}

export default UserProfile;
